import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService, SelectedCustomerService } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'car-liner-checkout-add-row-modal',
  templateUrl: './car-liner-checkout-add-row-modal.component.html',
  styleUrls: ['./car-liner-checkout-add-row-modal.component.scss'],
  standalone: false
})
export class CarLinerCheckoutAddRowModalComponent implements OnInit {
  private orderLineItemProductId = '46607-03';
  private orderLineItemNextIndex = 0;

  modalRows: {
    productId: string;
    productPartialId: string;
    quantity: number;
    price: number;
    name: string;
  }[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private cartService: CartService,
    private selectedCustomerService: SelectedCustomerService
  ) {}

  ngOnInit() {
    this.cartService
      .getCurrentCart()
      .pipe(first())
      .subscribe(cartRows => {
        const cartRowsItems = cartRows.filter(cartRow => cartRow.productId === this.orderLineItemProductId);

        // get next index to be partialId
        if (cartRowsItems.length > 0) {
          const cartRowsItemsNotInJeevesPartialIds = cartRowsItems.map(cartRow =>
            Number.parseInt(cartRow.productPartialId?.split(/[_]+/).pop() || '0', 10)
          );
          this.orderLineItemNextIndex = Math.max(...cartRowsItemsNotInJeevesPartialIds) + 1;
        }
      });
  }

  addNewRow() {
    this.modalRows.push({
      productId: this.orderLineItemProductId,
      productPartialId: this.orderLineItemProductId + '_' + new Date().getTime() + '_' + this.orderLineItemNextIndex,
      quantity: 1,
      name: '',
      price: 0
    });

    this.orderLineItemNextIndex++;
  }

  removeRow(index) {
    this.modalRows.splice(index, 1);
  }

  validateQuantity(value: number, rowIndex: number): void {
    if (value <= 0) {
      this.modalRows[rowIndex].quantity = 1;
    }
  }

  submitRows() {
    if (this.modalRows.length === 0) {
      this.activeModal.close();
      return;
    }

    for (const modalRow of this.modalRows) {
      const theOrp = {
        vb_pris: modalRow.price,
        ordantal: modalRow.quantity,
        artbeskr: modalRow.name
      };

      this.cartService.addToCart(
        modalRow.productId,
        modalRow.quantity,
        undefined,
        modalRow.productPartialId,
        undefined,
        {
          orp: theOrp,
          _userChangePrice: !!theOrp.vb_pris
        }
      );
    }

    this.activeModal.close();
  }
}
